export default "\n<app-step1 (step1ResultEvent)=\"this.getstep1Result($event)\"></app-step1>\n"